import React, { useCallback, useEffect } from "react";
import logoSuperDucha from "../../../../assets/images/logo-super-ducha-white.png";
import {
  setErrorMsg,
  setPage,
  setPaymentId,
  setCieloTransactionId,
  WashingStore,
} from "../../../../stores/WashingStore/WashingStore";
import { PAGES } from "../../../../stores/WashingStore/WashingStore.types";
import { EventSourceConfirmation } from "../../../../types/washing.types";
import { TextContainer } from "./ProcessingPaymentStyles";
import { createTotemTransaction } from "../../../../services/washingService";
import { useUnit } from "effector-react";
import {
  GradientContainer,
  LogoSuperDucha,
  LogoWrapper,
  Subtitle,
} from "../../TotemWashingStyles";
import { getPaymentConfirmation, getPaymentError } from "../../../../services/paymentStatus";

const ProcessingPayment: React.FC = () => {
  const { finalPrice, selectedPayment, totemId } = useUnit(WashingStore);

  const processPayment = useCallback(async () => {
    if (!selectedPayment?.type || !finalPrice) {
      return;
    }

    const payload = {
      amount: finalPrice.toString(),
      paymentType: selectedPayment?.type,
      totemId,
    };

    const result = await createTotemTransaction(payload);

    if (result.success !== true) {
      handleFailure();
    } else {
      let timeoutId: NodeJS.Timeout;

      const timeout = setTimeout(() => {
        clearTimeout(timeoutId);
        handleTimeout();
      }, 240000);

      const check = async () => {
        try {

          const date = result.data?.timestamp;

          const [responseConfirmation, responseError] = await Promise.all([
            getPaymentConfirmation(totemId, date || ""),
            getPaymentError(totemId, date || ""),
          ]);

          console.log("pooling...", { responseConfirmation, responseError });

          if (responseConfirmation?.id && responseConfirmation?.paymentId) {
            handleConfirmation(responseConfirmation.paymentId, responseConfirmation.id);
          } else if (responseError?.errorMessage) {
            handleError(responseError.errorMessage || "Erro desconhecido");
          } else {
            timeoutId = setTimeout(check, 2000);
          }

        } catch (err) {
          console.error("⚠️ Pooling error:", err);
          timeoutId = setTimeout(check, 2000);
        }
      };

      check();

      return () => {
        clearTimeout(timeout);
      };
    }
  }, [finalPrice, selectedPayment?.type, totemId]);

  useEffect(() => {
    processPayment();
  }, [processPayment]);

  const handleConfirmation = (paymentId: string, cieloTransactionId: string) => {
    setPaymentId(paymentId);
    setCieloTransactionId(cieloTransactionId);
    handleSuccess();
  };

  const handleError = (errorMessage: string) => {
    setErrorMsg(errorMessage);
    handleFailure();
  };

  const handleTimeout = () => {
    setErrorMsg("Tempo limite de espera atingido");
    setPage(PAGES.WASHING_PAYMENT_ERROR);
  };

  const handleSuccess = () => {
    setPage(PAGES.CHOOSE_TAX);
  };

  const handleFailure = () => {
    setPage(PAGES.WASHING_PAYMENT_ERROR);
  };

  return (
    <GradientContainer>
      <LogoWrapper>
        <LogoSuperDucha src={logoSuperDucha} alt="Super Ducha" />
      </LogoWrapper>
      <TextContainer>
        <Subtitle fontSize={"2.25rem"}>Processando pagamento...</Subtitle>
      </TextContainer>
    </GradientContainer>
  );
};

export default ProcessingPayment;
